import React from "react";
import {
  FaBell,
  FaCheckCircle,
  FaClock,
  FaCreditCard,
  FaEuroSign,
} from "react-icons/fa";

import {
  formatCurrency,
  formatNumber,
} from "../utils/adminSubscriptionsUtils";

function StatCard({ icon: Icon, label, value, description, tone = "blue" }) {
  const styles = {
    blue: "bg-sky-100 text-sky-700 dark:bg-sky-500/10 dark:text-sky-200",
    green:
      "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-200",
    amber:
      "bg-amber-100 text-amber-700 dark:bg-amber-500/10 dark:text-amber-200",
    red: "bg-red-100 text-red-700 dark:bg-red-500/10 dark:text-red-200",
    indigo:
      "bg-indigo-100 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-200",
  };

  return (
    <article className="rounded-[1.5rem] border border-slate-200 bg-white p-4 shadow-lg shadow-slate-200/50 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div className="flex items-start gap-3">
        <div
          className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl ${
            styles[tone] || styles.blue
          }`}
        >
          <Icon />
        </div>

        <div>
          <p className="font-titre text-3xl font-bold text-slate-950 dark:text-white">
            {value}
          </p>

          <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
            {label}
          </p>

          {description && (
            <p className="mt-1 text-xs font-medium text-slate-500 dark:text-white/45">
              {description}
            </p>
          )}
        </div>
      </div>
    </article>
  );
}

function SubscriptionStats({ stats }) {
  return (
    <section className="grid gap-4 sm:grid-cols-2 xl:grid-cols-5">
      <StatCard
        icon={FaCreditCard}
        label="Abonnements"
        value={formatNumber(stats.total)}
        description="Achats enregistrés"
        tone="blue"
      />

      <StatCard
        icon={FaCheckCircle}
        label="Actifs"
        value={formatNumber(stats.active)}
        description={`${stats.paid} paiement(s) réglé(s)`}
        tone="green"
      />

      <StatCard
        icon={FaClock}
        label="À renouveler"
        value={formatNumber(stats.dueSoon)}
        description="Échéance proche"
        tone="amber"
      />

      <StatCard
        icon={FaBell}
        label="Alertes"
        value={formatNumber(stats.alerts)}
        description={`${stats.expired} expiré(s), ${stats.unpaid} non réglé(s)`}
        tone={stats.alerts > 0 ? "red" : "indigo"}
      />

      <StatCard
        icon={FaEuroSign}
        label="CA réglé"
        value={formatCurrency(stats.revenue)}
        description="Total paiements réglés"
        tone="indigo"
      />
    </section>
  );
}

export default SubscriptionStats;